import { render, staticRenderFns } from "./WBtnClose.vue?vue&type=template&id=002673bc&scoped=true&"
import script from "./WBtnClose.vue?vue&type=script&lang=js&"
export * from "./WBtnClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002673bc",
  null
  
)

export default component.exports